import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "checkout" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent, onMounted } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexCheckout',
  setup(__props) {

const Card3 = defineAsyncComponent(() => import("@/components/common/card/CardData3.vue"))
const CheckoutForm = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/CheckoutForm.vue"))
const CheckoutDetail = defineAsyncComponent(() => import("@/components/theme/ecommerce/checkout/CheckoutDetail.vue"))

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Card3), {
      colClass: "container-fluid",
      headerTitle: "true",
      title: "Billing Details"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(CheckoutForm)),
          _createVNode(_unref(CheckoutDetail))
        ])
      ]),
      _: 1
    })
  ]))
}
}

})